export default __webpack_public_path__ + "cover.6f89f45e.png";